module.exports = __webpack_public_path__ + "static/media/C018.90778486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C018.jpg
// module id = 301
// module chunks = 0